import { Injectable } from '@angular/core';
import { Observable, Subject, empty, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  IUser as IUser, ILoginRequest, User, CreditCardDetails, ICreditInfoBody, IGetItemSuggestionsBody, ItemSuggestion, IUserLogin
  , BaseResponse,
  PWALoginRequest
} from '../models';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { CartService } from './cart.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  isKawneerAdmin(): boolean {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuserApplicationAdmin) > -1) return true;
    return false;
  }
  canManageAddress(): any {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuserAccountManager) > -1) return true;
    if (roleList.indexOf(this.roles.CustomerUserAdmin) > -1) return true;
    if (roleList.indexOf(this.roles.CSR) > -1) return true;
    if (roleList.indexOf(this.roles.INTuserAccountManager) > -1) return true;
    return this.hasAccessToPlaceOrder();
  }
  isPDMUser(): any {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTsampleAdmin) > -1) return true;
    return false;
  }
  isIntUser(): any {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuser) > -1) return true;
    return false;
  }
  isEXTUser(): any {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuser) > -1) return true;
    return false;
  }
  canManageExtUser(): any {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuserApplicationAdmin) > -1) return true;
    return false;
  }
  canSubmitFreightClaim(): any {
    //return false;
    //if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTFreightClaimUser) > -1) return true;
    return false;
  }
  canMangeFreightClaim(): any {
    //return false;
    //if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTFreightClaimAdmin) > -1) return true;
    return false;
  }

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router) {
    this.init();
  }
  async init() {
    let user = this.readUserObject1();
    if (!user) { user = new User(); }
    if (!user.userLanguage) { user.userLanguage = 'eng'; }
    this.saveUserObject(user);
  }
  //#region UserService Api endPoints
  public validateToken() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.VALIDATE_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
  }

  public ChangePassword(data): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.CHANGE_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
  }
  public changeDefaultPassword(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.CHANGE_DEFAULT_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public ForgotPassword(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.FORGOT_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }

  public acceptTermConditions(body): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.ACCEPT_TERM_CONDITION}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body);
  }
  public getAll(): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_ALL_USERS}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint);
  }
  public getWorkListUsers(): Observable<Array<IUser>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_WORKLIST_USERS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, {}).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getUserByCustomerNumber(customerNumber: string): Observable<IUser[]> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_USER_BY_CUSTOMER_NUMBER}?customerNumber=${customerNumber}`;

    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      map((response: any) => response),
      catchError(err => {
        console.error(err);
        return of([]);
      })
    );
  }
  public getUserForTransferQuote(quoteCommonId: string): Observable<any> {

    const apiEndpoint =`${ConfigService.APIs.endPoints.USER.GET_USERS_FOR_TRANSFER_QUOTE}/${quoteCommonId}`;

    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
      .pipe(
        map((response: any) => response),
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
  public addUser(body: IUser): Observable<IUser> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.ADD_USER}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  //couldn't find any reference for this method
  public updateUser(body: IUser): Observable<IUser> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.UPDATE_USER}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public deleteUser(body: IUser): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.DELETE_USER}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public registerUser(data): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.NEW_USER}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
  }
  public isUserNameAvailable(userName): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.VALID_USERNAME}/${userName}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
  }
  //#region LOGIN & LOGOUT
  public logout() {
    //to unsubscribe from idle session
    try {
      if (this.readUserObject && this.readUserObject.userName != "") {
        this.ToggleIdleSession.next(false);
        this.isUserLoggedIn.next(false); // to show hide footer
        console.log("loggedOut " + this.readUserObject.userName);
        this.deleteRefreshToken().subscribe(response => {
          //this.stopRefreshTokenTimer();
        });
      }
      //this.authService.logout();
    }
    catch (ex) { }
    finally {
      this.stopRefreshTokenTimer();
      this.authService.logout();
    }
    const u = new User();
    u.userLanguage = 'eng';
    this.saveUserObject(u);
    this.router.navigate(['/home']);


  }
  public async ConfirmForgotPasswordOtp(body: any) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.CONFIRM_FORGOT_PASSWORD_OTP}`;
    let confirmotpResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, body).toPromise()).then((r) => {
      confirmotpResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        confirmotpResp = e.error;
      }
    });
    return confirmotpResp;
  }
  public async ForgotPasswordResend(body: any) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.FORGOT_PASSWORD}`;
    let confirmotpResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, body).toPromise()).then((r) => {
      confirmotpResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        confirmotpResp = e.error;
      }
    });
    return confirmotpResp;
  }

  public async login(login: ILoginRequest) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.LOGIN}`;
    let loginResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, login).toPromise()).then((r) => {
      loginResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        loginResp = e.error;
      }
    });
    return loginResp;
  }

  public async pwaUserLoginLog(log: PWALoginRequest) {
    const endPoint = `${ConfigService.APIs.endPoints.USER.PWA_LOGIN_LOG}`;
    let logResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, log).toPromise()).then((r) => {
      logResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        logResp = e.error;
      }
    });
    return logResp;
  }

  public GetOutageObj(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MARKETING_ADMIN.GET_OUTAGEOBJ}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, {}).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => {
        return response;
      })

    );
  }
  public async getUserDetails() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_DETAILS}`;
    let userDetails;
    await (ApiService.genericObservableGet(this.httpClient, apiEndpoint).toPromise()).then(r => {
      if (!r.isError) {
        userDetails = r.data;
      }
    }).catch(e => { });
    return userDetails;
  }

  public logoutUnAuthorized() {

    if (this.readUserObject && this.readUserObject.userName != "") {
      this.ToggleIdleSession.next(false);
      this.isUserLoggedIn.next(false); // to show hide footer
      this.deleteRefreshToken().subscribe(response => {
        this.stopRefreshTokenTimer();
      }, error => { this.stopRefreshTokenTimer(); });
    }
    this.authService.logout();
    const u = new User();
    u.userLanguage = 'eng';
    this.saveUserObject(u);
    this.UnAuthReq.next(true);
    //this.router.navigate(['/unauthorized']);
    this.router.navigate(['/home']);


  }
  //#endregion
  //#region LGGED IN USER 
  public isAuthenticated(): boolean {

    return this.authService.isAuthenticated();
  }
  //#endregion
  //#region USER OBJ/TOKEN IN LOCAL STORAGE
  localStorageUserKey: string = 'user';
  ToggleIdleSession: Subject<boolean> = new Subject<boolean>();

  OutageObject: Subject<any> = new Subject<any>();
  UnAuthReq: Subject<boolean> = new Subject<boolean>();

  LogoutTrigger: Subject<boolean> = new Subject<boolean>();
  public isUserLoggedIn: Subject<boolean> = new Subject<boolean>(); // to show hide footer
  
  public saveUserObject(login: IUser) {
    //to subscribe to the idle session
    if (login.userName != "") {
      this.ToggleIdleSession.next(true);
      this.isUserLoggedIn.next(true);
      //console.log("userSignedIn " + JSON.stringify(login));
    }

    localStorage.setItem(this.localStorageUserKey, JSON.stringify(login));
  }

  public readUserObject1(): IUser {
    return JSON.parse(localStorage.getItem(this.localStorageUserKey)) as IUser;
  }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem(this.localStorageUserKey)) as IUser;
  }
  public saveToken(token: string) {
    this.authService.saveToken(token);
    this.startRefreshTokenTimer();
  }
  //#endregion

  //#region role check
  roles = {
    CustomerUserAdmin: 'CustomerUserAdmin',
    EXTuser: 'EXTuser',
    EXTuserAccountManager: 'EXTuserAccountManager',
    EXTuserAccountSummary: 'EXTuserAccountSummary',
    EXTuserInvoice: 'EXTuserInvoice',
    EXTuserManagePayments: 'EXTuserManagePayments',
    INTuser: 'INTuser',
    INTuserAccountManager: 'INTuserAccountManager',
    INTuserApplicationAdmin: 'INTuserApplicationAdmin',
    INTuserMarketingAdmin: 'INTuserMarketingAdmin',
    INTuserV6Admin: 'INTuserV6Admin',
    SystemUserAdmin: 'SystemUserAdmin',
    CSR: 'CSC',
    MultiCustomerAccount: 'MultiCustomerAccount',
    InvoicePaymentACH: 'EXTuserManagePaymentsACH',
    InvoicePaymentCreditCard: 'EXTuserManagePaymentsCC',
    INTFreightClaimAdmin: 'INTFreightClaimAdmin',
    EXTFreightClaimUser: 'EXTFreightClaimUser',
    //#Region Product Sample Fulfillment
    INTsampleAdmin: 'INTsampleAdmin',
    //#End Region
    INTclearanceUser: 'INTclearanceUser',
    INTclearanceAdmin: 'INTclearanceAdmin',
    EXTcheckoutCConly: 'EXTcheckoutCConly',
    EXTcheckoutCC: 'EXTcheckoutCC'
  }; 
  public isSuperAdmin() {
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.SystemUserAdmin) > -1) return true;
    return false;
  }

  public isV6Admin() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuserV6Admin) > -1) return true;
    return false;
  }
  public isMarketingAdmin() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuserMarketingAdmin) > -1) return true;
    return false;
  }
  public isMktAdmin() {
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTuserMarketingAdmin) > -1) return true;
    return false;
  }
  public isCustomerAdmin() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuserAccountManager) > -1) return true;
    if (roleList.indexOf(this.roles.CustomerUserAdmin) > -1) return true;
    return false;
  }
  public isCSR() {
    //if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.CSR) > -1) return true;
    return false;
  }
  public isMultiCustomerAccount() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.MultiCustomerAccount) > -1) return true;
    return false;
  }
  public hasAccessToAccountSummary() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuserAccountSummary) > -1) return true;
    if (this.isCSR() && roleList.indexOf(this.roles.INTuser) > -1) return true;
    return false;
  }
  public hasAccessToInvoiceInquiry() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuserInvoice) > -1) return true;
    //if (roleList.indexOf(this.roles.MultiCustomerAccount) > -1) return true;
    if (this.isCSR() && roleList.indexOf(this.roles.INTuser) > -1) return true;
    return false;
  }
  public hasAccessToClearanceStoreItemMgmt() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTclearanceAdmin) > -1) return true;
    return false;
  }
  public hasAccessToClearanceStoreOrderMgmt() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTclearanceAdmin) > -1) return true;
    if (roleList.indexOf(this.roles.INTclearanceUser) > -1) return true;
    return false;
  }
  //#region Sample Product Fulfillment
  public hasAccessToAdminMenu() {
    if (this.isV6Admin() || this.isMarketingAdmin() || this.canMangeFreightClaim() || this.isKawneerAdmin()
      || this.isSampleProductAdmin() ||
      this.hasAccessToClearanceStoreOrderMgmt() ||
      this.hasAccessToClearanceStoreItemMgmt()) return true;
    return false;
  }
  public hasAccessToPlaceOrder() {
    if (this.isSuperAdmin()) return true;
    if (this.isCSR()) return false;
    const roleList = this.authService.getRolesFromToken();
    if (this.readUserObject.canPlaceOrder) return true;
    return false;
  }
  public isVisibleManageCompany() {
    // isSuperAdmin || isCustomerAdmin || isCSR || EXTuserAccountManager
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTuserAccountManager) > -1) return true;
    if (roleList.indexOf(this.roles.CustomerUserAdmin) > -1) return true;
    if (roleList.indexOf(this.roles.CSR) > -1) return true;
    //if (roleList.indexOf(this.roles.INTuserAccountManager) > -1) return true;

  }
  public hasAccessToMakeInvoicePayment() {
    //if (this.readUserObject && this.readUserObject.currencyCode !== 'USD') return false;    
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.InvoicePaymentACH) > -1 || roleList.indexOf(this.roles.InvoicePaymentCreditCard) > -1) return true;
    return false;
  }
  public hasAccessToMakeACHInvoicePayment() {
    //if (this.readUserObject && this.readUserObject.currencyCode !== 'USD') return false;    
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.InvoicePaymentACH) > -1) return true;
    return false;
  }
  public hasAccessToMakeCreditCardInvoicePayment() {
    //if (this.readUserObject && this.readUserObject.currencyCode !== 'USD') return false;    
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.InvoicePaymentCreditCard) > -1) return true;
    return false;
  }
  //#Region Product Sample Fulfillment
  public isSampleProductAdmin() {
    if (this.isSuperAdmin()) return true;
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.INTsampleAdmin) > -1) return true;
    if (roleList.indexOf(this.roles.INTuserApplicationAdmin) > -1) return true;
    return false;
  }
  //#End Region
  //public isDiscountAvailableForTheUser() {
  //  var paymentTerms: string = 'D15';
  //  if (paymentTerms === 'D15') {
  //    return true;
  //  }
  //  else {
  //    return false;
  //  }
  //}
  //#endregion
  public getCreditInfo(): Observable<CreditCardDetails> {
    const data: ICreditInfoBody = {
      customerNumber: this.readUserObject.customerNumber,
    }

    const endPoint = `${ConfigService.APIs.endPoints.USER.CREDIT_INFO}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((creditCardInfo) => { this.CREDIT_INFO = creditCardInfo }))
  }
  private CREDIT_INFO: CreditCardDetails = null;

  public get creditCardInfo(): CreditCardDetails {
    return this.CREDIT_INFO;
  }
  public set creditCardInfo(creditCardInfo: CreditCardDetails) {
    this.CREDIT_INFO = creditCardInfo
  }
  //#endregion

  //#region Business Logic UserService Localstorage Methods


  //#endregion
  //#region manage company user accounts access--Need to change condition
  public loggedInAccountType() {
    if (this.readUserObject.isCSCAccount) {
      return "cscAccount";
    } else {
      return "adminAccount";
    }

  }
  //#endregion

  //#region User administration
  public getAllRoles(): Observable<Array<any>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_ALLROLES}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getAllCustomers(): Observable<Array<any>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_ALLCUSTOMERS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, {}).pipe(
      catchError((err, caught) => { this.handleError(err); return empty(); }),
      map((response: BaseResponse) => {
        if (response.isError) {
          this.handleError(response.errorMessage);
        }
        else {
          return response.data;
        }
      })
    );
  }
  public getAllCustomersForAdmin(): Observable<Array<any>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_ALLCUSTOMERS_FOR_ADMIN}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, {}).pipe(
      catchError((err, caught) => { this.handleError(err); return empty(); }),
      map((response: BaseResponse) => {
        if (response.isError) {
          this.handleError(response.errorMessage);
        }
        else {
          return response.data;
        }
      })
    );
  }
  public loadUserDetailsForEdit(userId): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.GET_EDIT_USER_DETAILS}/${userId}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
  }
  //#endregion

  //public get loggedInUser(): IUser {
  //  return JSON.parse(localStorage.getItem(this.localStorageUserKey)) as IUser;
  //}

  public refresh(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.USER.GET_NEW_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  public deleteRefreshToken(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.USER.DELETE_REFRESH_TOKEN}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }
  //#region roles

  private handleError(error: any) {
    if (Error instanceof HttpErrorResponse) {
      console.log(error.status);
    }
    else {
      console.error("an error occurred here");
    }
    this.router.navigate(['/error']);
  }
  private refreshTokenTimeout;
  private startRefreshTokenTimer() {
    // set a timeout to refresh the token a minute before it expires
    const expires = this.authService.getTokenExpirationDate();
    const timeout = 20 * 60000; //expires.getTime() - Date.now() - (10 * 60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.refresh().subscribe(response => {
      this.saveToken(response.token);
    }), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  public ForgotUsername(body): Observable<any> {
    const apiEndpoint = `/User/ForgotUsername`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }

  //#region role check for cc phase 3
  paymentTermsListOfCCCustomer = ["CIA"];
  public isCheckoutCConlyCustomer() {
    //for test only since we dont have customer with proper payment terms setup as of now
    //start
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false; 
    let paymentTerms = this.readUserObject.paymentTerms;
    if ((roleList.indexOf(this.roles.EXTcheckoutCConly) > -1)) { return true; }
    return false;
    //end


    //const roleList = this.authService.getRolesFromToken();
    //if (!roleList) return false;
    ////for CC only customer they must have payment terms as CIA as well as the CC only role
    //let paymentTerms = this.readUserObject.paymentTerms;
    //if ((roleList.indexOf(this.roles.EXTcheckoutCConly) > -1)
    //  && paymentTerms
    //  && (this.paymentTermsListOfCCCustomer.indexOf(paymentTerms) > -1)) { return true; }
    //return false;
  }
  public isCheckoutCCCustomer() {

    //for test only since we dont have customer with proper payment terms setup as of now
    //start
    const roleList = this.authService.getRolesFromToken();
    if (!roleList) return false;
    if (roleList.indexOf(this.roles.EXTcheckoutCC) > -1) return true;
    return false;
    //end
  }
  //#endregion
  public async fetchFreightEstimateFlag() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.Fetch_Freight_Estimate_Flag}`;
    await (ApiService.genericObservableGet(this.httpClient, apiEndpoint).toPromise()).then(r => {
      if (!r.isError) {
        var freightEstimateFlag = r == 1 ?  true :  false;
        localStorage.setItem('KDFreightEstimateFlag', JSON.stringify(freightEstimateFlag));
      }
    }).catch(e => { });
  }
  public async fetchFreightEstimateNoteFlag() {
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.Fetch_Freight_Estimate_Note_Flag}`;
    await (ApiService.genericObservableGet(this.httpClient, apiEndpoint).toPromise()).then(r => {
      if (!r.isError) {
        var freightEstimateNoteFlag = r == 1 ? true : false;
        localStorage.setItem('KDFreightEstimateNoteFlag', JSON.stringify(freightEstimateNoteFlag));
      }
    }).catch(e => { });
  }
  public async getTextVersion() {
    let version: number = 0;
    const apiEndpoint = `${ConfigService.APIs.endPoints.USER.Get_Text_Version}`;
    await (ApiService.genericObservableGet(this.httpClient, apiEndpoint).toPromise()).then(r => {
      if (!r.isError) {
        version = r;
      }
    }).catch(e => { });
    return version;
  }

  public getFreightEstimateFlag() {
     return JSON.parse(localStorage.getItem('KDFreightEstimateFlag')) as boolean;
  }
  public getFreightEstimateNoteFlag() {
    return JSON.parse(localStorage.getItem('KDFreightEstimateNoteFlag')) as boolean;
  }
}
